import { createValidator, richTextMaxLength } from 'util/validation'

import { PlanoFormModel } from './PlanoForm'

export const planoValidator = createValidator<PlanoFormModel>({
  texto: [richTextMaxLength(4000)],
})
